import { useEffect, useRef, useState } from "react";

/**
 * Animates a number from 0 to `end` once the element enters viewport.
 */
export default function useCountUp(end, duration = 1800) {
    const ref = useRef(null);
    const [value, setValue] = useState(0);
    const started = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !started.current) {
                        started.current = true;
                        const start = performance.now();
                        const step = (now) => {
                            const t = Math.min(1, (now - start) / duration);
                            const eased = 1 - Math.pow(1 - t, 3);
                            setValue(Math.round(eased * end));
                            if (t < 1) requestAnimationFrame(step);
                        };
                        requestAnimationFrame(step);
                        io.disconnect();
                    }
                });
            },
            { threshold: 0.4 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [end, duration]);

    return [ref, value];
}
